module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"notfound":"No articles found","addToCollection":"Add to collection"}}}')
  delete Component.options._Ctor
}
